import React from 'react';
import './HowTo.css';

import CurvedBottom from '../../../components/CurvedBottom/CurvedBottom';
import Slideshow from '../../../components/Slideshow/Slideshow';

const howTo = ( props ) => (
	<section id="HowTo" className="hasCurve">
		<Slideshow slides={ props.slides } />
		<CurvedBottom />
	</section>
);

export default howTo;



// WEBPACK FOOTER //
// ./src/pages/Communication/HowTo/HowTo.js